import React from 'react';
import styled from 'styled-components';

import FormStylesOptions from '../../../constants/FormStylesOptions';
import FieldModes from '../../../constants/FieldModes';
import PageLayoutModes from '../../../constants/PageLayoutModes';
import FieldPresentationModes from '../../../constants/FieldPresentationModes';

const inputStyles = (props) => {
  return `
    height: 100%;
    width:${props.width};
    background-color: ${props.backgroundColor};
    font-size: ${props.fontSize}px !important;
    color: ${props.fontColor};
    font-style: ${props.fontStyle};
    font-weight: ${props.fontWeight};
    text-align: ${props.textAlign};
    text-transform: ${props.textTransform};
    text-decoration: ${props.textDecoration};
    ${props.textOverflow ? `text-overflow: ${props.textOverflow};` : ''}
    border-radius: ${props.borderRadius}px;
    border: ${props.border};
    padding: ${props.padding}px;
    resize: none;
    transition: border 0.15s ease-in-out;

    &:focus, &:focus-visible {
      outline: unset;
      border: ${props.borderWidth}px solid ${props.primaryColor};
    }

    &:hover {
      ${props.disabled ? '' : `border: ${props.borderWidth}px solid ${props.primaryColor}`};
    }
    
    min-height: ${(props) => props.minHeight ? `${props.minHeight}px`: ''}

  `;
};

const StyledInput = styled.input`
  ${(props) => inputStyles(props)}
`;

/*
const StyledTextarea = styled.textarea`
  ${(props) => inputStyles(props)}
  overflow: hidden;
`;
*/

const StyledSpan = styled.span`
  ${(props) => inputStyles(props)}
  white-space:pre-line;
  overflow-wrap: break-word;
`;

/**
 * This components main purpose is to isolate the input
 * styles into one location and not require style updates
 * all over the place when we update it in the future.
 */
const FieldInput = (props) => {

  const { borderWidth, borderColor, value, textOverflow, fieldMode, pageLayoutMode, fieldPresentationMode } = props;

  /**
   * We join width and color to a single border style because chrome displays
   * the border as a two tone color if you use border-color and border-width
   * indvidually.
   */
  const border = `${borderWidth}px solid ${borderColor}`;

  let inputNode = <StyledInput {...props} border={border} />;

  /**
   * <----------NOTICE------------------>
   *
   * Wrapping is only applied in read-only mode.
   *
   * Field values of various text fields like text, number ,dropdown, multiselect,
   * individual text cells must be wrapped when textWrapping is set to wrap.
   *
   * If text wrapping is set to wrap, we use a text area to display the field value across
   * multiple lines as text input doesn't support multiple lines.
   *
   * Date fields are excluded since it can not be embedded within a textarea
   * like other text fields. datetime-local and time denote the html input types
   * that we pass in to the field input.
   */
  /*
   * DISABLED NOTE: Disabiling due to impact on PDF forms. Need to come back and
   * see what the proper fix is.
   * if (
    fieldMode === FieldModes.readonly
    && textOverflow !== FormStylesOptions.textOverflowEllipsis
    && type !== FieldTypes.date
    && type !== 'datetime-local'
    && type !== 'time'
  ) {
    inputNode = <StyledTextarea {...props} border={border} />;
  }*/

  /**
   * <-----------NOTICE--------------->
   * Logic below ensures that Field Wrapping Doesn’t Cut Off Text for PDFs and PDF Exports
   * We use the span element to make the field value bleed over it's border incase the field doesn't have
   * adequate height to incorporate the whole field value in PDF exports.
   */
  if (fieldMode === FieldModes.readonly
    && pageLayoutMode === PageLayoutModes.float
    && fieldPresentationMode === FieldPresentationModes.transparent
    && textOverflow !== FormStylesOptions.textOverflowEllipsis) {
    inputNode = (
      <StyledSpan {...props} border={border}>
        {value}
      </StyledSpan>
    );
  }

  return inputNode;

};

export default React.memo(FieldInput);
